import { Box } from "@mui/material";
import DrawerAwareContainerComponentViewModel from "src/app/components/drawerAwareContainer/drawerAwareContainer.viewmodel";
import DrawerAwareContainerModel from "src/app/models/components/drawerAwareContainer.model";

const DrawerAwareContainerComponentView: React.FC<DrawerAwareContainerModel> = (
  drawerAwareContainerProps: DrawerAwareContainerModel,
) => {
  const { sx, drawerWidth, children } = drawerAwareContainerProps;
  const { isMobile } = DrawerAwareContainerComponentViewModel();
  return (
    <Box sx={[sx ?? {}, { marginLeft: isMobile ? "0px" : `${drawerWidth}px` }]}>
      {children}
    </Box>
  );
};

export default DrawerAwareContainerComponentView;
